/* eslint-disable no-underscore-dangle */
/* eslint-disable import/named */
/* eslint-disable no-console */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import moment from 'moment';
import { setNotification, operatorTyping } from 'utils';
import * as JobActions from '../actions/jobActions';
import * as JobTypes from '../types/jobTypes';
import { LOAD_PLANNING } from '../types/planningTypes';
import { getJobApi, toggleJobStatusApi, addJobErrorApi } from '../api/jobApi';
import { addJobPaletteApi } from '../api/jobResultApi';

const getLayout = state => state.layout;
const getJobs = state => state.jobs;

// L O A D   J O B S
function* loadJobsSaga() {
    const { offset, limit, filters, sort } = yield select(getJobs);

    try {
        const params = {
            limit,
            offset,
            joins: JSON.stringify(['order_item', 'form_version', 'form']),
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'quantity') {
                params.sort_by = JSON.stringify({ quantity: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'job_number') {
                params.sort_by = JSON.stringify({ job_number: sortInt });
            } else if (sort.key === 'expectedShippingDate') {
                params.sort_by = JSON.stringify({ 'order_item.expected_shipping_date_sort': sortInt });
            }
        }

        const sendFilters = {
            join: null,
        };

        if (filters.machine_ids !== '') {
            sendFilters.machine_ids = filters.machine_ids;
        }

        if (filters.formVersionId !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'form_version.form_version_number': operatorTyping(filters.formVersionId.trim()),
            };
        }

        if (filters.formId !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'form.form_number': operatorTyping(filters.formId.trim()),
            };
        }

        if (filters.jobId !== '') {
            sendFilters.job_number = operatorTyping(filters.jobId.trim());
        }

        if (filters.designId !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'order_item.design_id': operatorTyping(filters.designId.trim()),
            };
        }

        if (filters.orderItemId !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'order_item.order_item_number': operatorTyping(filters.orderItemId.trim()),
            };
        }

        if (filters.customer !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'order_item.customer_name': operatorTyping(filters.customer.trim()),
            };
        }

        if (filters.machine !== undefined) {
            sendFilters.current_machine = filters.machine;
        }

        if (filters.size !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'form.sizes': operatorTyping(filters.size.trim()),
            };
        }

        if (filters.carpetQuality !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'order_item.configurations.configurations_property.name.value': operatorTyping(filters.carpetQuality.trim()),
            };
        }

        if (filters.status !== undefined) {
            sendFilters.state = filters.status;
        }

        if (filters.quantity !== '') {
            sendFilters.quantity = parseInt(filters.quantity, 10);
        }

        if (filters.startDate.length > 0) {
            const customDate = [
                moment.utc(filters.startDate[0]).format('YYYY-MM-DD 00:00:00'),
                moment.utc(filters.startDate[1]).format('YYYY-MM-DD 23:59:59'),
            ];
            sendFilters.production_date = { between: customDate };
        }

        if (filters.expectedEndDate.length > 0) {
            const customDate = [
                moment.utc(filters.expectedEndDate[0]).format('YYYY-MM-DD 00:00:00'),
                moment.utc(filters.expectedEndDate[1]).format('YYYY-MM-DD 23:59:59'),
            ];
            sendFilters.expected_finish_date = { between: customDate };
        }

        if (filters.job_palette !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                job_palette_number: operatorTyping(filters.job_palette.trim()),
            };
        }

        if (filters.barcode !== '') {
            sendFilters.join = {
                ...sendFilters.join,
                'order_item.barcode': operatorTyping(filters.barcode.trim()),
            };
        }

        if (filters.palette !== '') {
            sendFilters.palettes = operatorTyping(filters.palette.trim());
        }

        params.filter = JSON.stringify(sendFilters);

        const result = yield getJobApi(params);

        if (result.status === 200) {
            yield put(JobActions.loadJobsRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(JobActions.loadJobsErr());
    }
}

export function* loadJobsWatcher() {
    yield takeLatest(JobTypes.LOAD_JOBS, loadJobsSaga);
}
// L O A D   J O B S

// T O G G L E   J O B  S T A T U S
function* toggleJobStatusSaga(action) {
    try {
        const { locale } = yield select(getLayout);
        const result = yield toggleJobStatusApi(action.data);
        if (result.status === 202) {
            if (action.data.step_state === 'IN_PROGRESS') {
                setNotification('success', locale, 'global.success', 'jobs.notification.startMachineSuccess');
            } else {
                setNotification('success', locale, 'global.success', 'jobs.notification.stopMachineSuccess');
            }

            if (action.load === 'planning') {
                yield put({ type: LOAD_PLANNING });
            } else {
                yield call(loadJobsSaga, {});
            }
        } else if (action.data.step_state === 'IN_PROGRESS') {
            setNotification('error', locale, 'global.error', 'jobs.notification.startMachineError');
        } else {
            setNotification('error', locale, 'global.error', 'jobs.notification.stopMachineError');
        }
    } catch (e) {
        console.log(e);
    }
}

export function* toggleJobStatusWatcher() {
    yield takeLatest(JobTypes.TOGGLE_JOB_STATUS, toggleJobStatusSaga);
}
// T O G G L E   J O B  S T A T U S

// T O G G L E   J O B   S T E P S
function* toggleJobStepsSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        let params = {};

        if (action.multiple) {
            params = action.bulkParams;
        } else {
            params = {
                job_id: action.id[0],
            };
        }

        const result = yield toggleJobStatusApi(params);

        if (result.status === 202) {
            if (!action.multiple) {
                setNotification('success', locale, 'global.success', `jobs.notification.toggleSteps.${action.status}.success`);
                yield put(JobActions.toggleJobStepRes());
            } else {
                setNotification('success', locale, 'global.success', `jobs.notification.bulkSteps.${action.status}.success`);
                yield put(JobActions.bulkCheckedJobRes());
            }

            yield call(loadJobsSaga, {});
        } else if (!action.multiple) {
            setNotification('error', locale, 'global.error', `jobs.notification.toggleSteps.${action.status}.error`);
            yield put(JobActions.toggleJobStepErr());
        } else {
            setNotification('error', locale, 'global.error', `jobs.notification.bulkSteps.${action.status}.error`);
            yield put(JobActions.bulkCheckedJobErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', `jobs.notification.toggleSteps.${action.status}.error`);
        yield put(JobActions.toggleJobStepErr());
        console.log(e);
    }
}

export function* toggleJobStepsWatcher() {
    yield takeLatest(JobTypes.TOGGLE_JOB_STEPS, toggleJobStepsSaga);
}
// T O G G L E   J O B   S T E P S

// B U L K   C H E C K E D   J O B
function* bulkCheckedJobSaga(action) {
    const { locale } = yield select(getLayout);
    const { listing } = yield select(getJobs);
    const { bulk, ids } = action;

    try {
        const bulkParams = { bulk: [] };
        const configs = listing.hits.filter(c => ids.includes(c._id));

        if (bulk === 'disable') {
            for (let i = 0; i < configs.length; i += 1) {
                if (configs[i].current_machine) {
                    bulkParams.bulk = bulkParams.bulk.concat({
                        job_id: configs[i]._id,
                        machine_id: configs[i].current_machine,
                        step_state: 'DONE',
                    });
                }
            }
        }

        if (bulk === 'enable') {
            for (let i = 0; i < configs.length; i += 1) {
                if (configs[i].next_machine) {
                    bulkParams.bulk = bulkParams.bulk.concat({
                        job_id: configs[i]._id,
                        machine_id: configs[i].next_machine,
                        step_state: 'IN_PROGRESS',
                    });
                }
            }
        }

        yield call(toggleJobStepsSaga, {
            status: bulk,
            bulkParams,
            multiple: true,
        });
    } catch (e) {
        setNotification('error', locale, 'global.error', `jobs.notification.bulkSteps.${bulk}.error`);
        yield put(JobActions.bulkCheckedJobErr());
        console.log(e);
    }
}

export function* bulkCheckedJobWatcher() {
    yield takeLatest(JobTypes.BULK_CHECKED_JOB, bulkCheckedJobSaga);
}
// B U L K   C H E C K E D   J O B

// A D D   J O B   P A L L E T E
function* addJobPaletteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield addJobPaletteApi(action.data);

        if (result.status === 202) {
            yield put(JobActions.addJobPaletteRes(true, false));
            yield delay(1000);
            if (action.from === 'rolls_out') {
                yield put(JobActions.addJobPaletteRes(false, true));
            } else if (action.from === 'rolls_out_overview') {
                yield put(JobActions.addJobPaletteRes(false, true));
            } else {
                yield put(push('/pp/jobs/'));
                yield put(JobActions.addJobPaletteRes(false, true));
            }
            yield delay(1000);
            yield put(JobActions.addJobPaletteRes(false, false));

            setNotification('success', locale, 'global.success', 'jobs.notification.addJobResult.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(JobActions.addJobPaletteErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'jobs.notification.addJobResult.error');
        yield put(JobActions.addJobPaletteErr());
        console.log(e);
    }
}

export function* addJobPaletteWatcher() {
    yield takeLatest(JobTypes.ADD_NEW_PALLETE_JOB, addJobPaletteSaga);
}
// A D D   J O B   P A L L E T E

// A D D   J O B   E R R O R
function* addJobErrorSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield addJobErrorApi(action.data);

        if (result.status === 202) {
            yield put(JobActions.addJobErrorRes());
            yield call(loadJobsSaga, {});
            setNotification('success', locale, 'global.success', 'formVersion.notification.reportJobError.Success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(JobActions.addJobErrorErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'formVersion.notification.reportJobError.Error');
        yield put(JobActions.addJobErrorErr());
        console.log(e);
    }
}

export function* addJobErrorWatcher() {
    yield takeLatest(JobTypes.ADD_NEW_ERROR_JOB, addJobErrorSaga);
}
// A D D   J O B   E R R O R
